import styled from '@emotion/styled';

export default styled.div`
	position: relative;
	width: 100%;

	.headline {
		font-size: 2em;
		font-weight: 700;
	}

	.cities-list {
		display: flex;
		align-items: center;
		justify-content: flex-start;
		padding: 1.8em 0;

		.city {
			font-size: 1.1em;
			font-weight: 400;
			border: 0.01em solid #000000;
			padding: 0.8em 0;
			text-align: center;
			background-color: #ffffff;
			cursor: pointer;
			width: 100%;
			text-transform: capitalize;

			&:hover {
				background-color: #000000;
				color: #ffffff;
			}

			&.active {
				background-color: #000000;
				color: #ffffff;
			}
		}
	}

    /* Temporarily Martyna asked for exclusioned! */
	.districts-list {
		display: none;
	}

	/* .districts-list {

    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;

    .commune {
        font-size: 1.12em;
        font-weight: 400;
        cursor: pointer;

        &:hover {
            font-weight: 700
        }

        &.active {
            font-weight: 700;
        }

        &:not(:last-child) {
            margin-right: 1em;
        }
    }
} */
`;
